import type { FC } from "react";
import { Button } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import { useTranslation } from "@/shared/hooks";

// Кнопка «Поделиться» строки контролов (референсный ShareButton):
// navigator.share на поддерживающих устройствах, иначе копирование ссылки.
export const ShareButton: FC<{ title: string; url: string }> = ({
  title,
  url,
}) => {
  const { t } = useTranslation();

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch {
        // пользователь закрыл системный шэр
      }
    } else {
      await navigator.clipboard.writeText(url);
    }
  };

  return (
    <Button
      variant="outlined"
      color="inherit"
      startIcon={<ShareIcon fontSize="small" />}
      size="small"
      onClick={() => void handleShare()}
      sx={{ whiteSpace: "nowrap" }}
    >
      {t("video.actions.share")}
    </Button>
  );
};
